export default __webpack_public_path__ + "6b7119c9792a53a9d88e62f11abaca8b.png";